import IconWithTooltip from './IconWithTooltip';

export default IconWithTooltip;
